import styled, { keyframes } from "styled-components";

export const HouseCardToFavoritePageContainer = styled.div`
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;
	gap: 18px;
	align-content: flex-start;
	justify-content: flex-start;
	margin-top: 8px;

	> div {
		display: block;
		margin: 0;
		flex: 0 0 auto;
	}

	@media (max-width: 767px) {
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		max-width: 310px;
		margin-left: auto;
		margin-right: auto;
	}
`;

export const EmptyFavoritesContainer = styled.div`
	margin-top: 18px;
	width: 100%;
	max-width: 100%;
	min-height: 280px;
	box-sizing: border-box;

	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 24px 16px;

	> h1 {
		font-size: 28px;
		font-weight: bold;
		line-height: 1.25;
		margin: 0;
	}

	@media (min-width: 768px) {
		> h1 {
			font-size: 36px;
		}
	}

	@media (max-width: 767px) {
		margin-bottom: 24px;
		width: 100%;
		max-width: 310px;
		margin-left: auto;
		margin-right: auto;

		> h1 {
			font-size: 22px;
		}
	}
`;

export const Card = styled.div`
	width: 250px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	border: 1px solid #b6b6b6;
	border-radius: 16px;

	cursor: pointer;

	@media (min-width: 1441px) {
		width: 295px;
	}

	@media (max-width: 767px) {
		width: 100%;
		max-width: 310px;
		margin-left: auto;
		margin-right: auto;
	}
`;

/** Área fixa do carrossel: imagem não ultrapassa nem empurra o conteúdo abaixo */
export const CardImageSliderWrap = styled.div`
	width: 100%;
	height: 175px;
	flex-shrink: 0;
	overflow: hidden;
	border-radius: 16px 16px 0 0;
	position: relative;
	background: #ececec;

	.slick-slider,
	.slick-list,
	.slick-track {
		height: 100%;
	}

	.slick-list {
		overflow: hidden;
		margin: 0;
	}

	.slick-slide {
		height: 100%;
	}

	.slick-slide > div {
		height: 100%;
	}

	.slick-slide img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
		display: block;
		border-radius: 0;
	}

	.slick-prev:before,
	.slick-next:before {
		color: #212121;
	}

	.slick-prev,
	.slick-next {
		background: #fff;
		position: absolute;
		top: 50%;
		z-index: 2;
		border-radius: 50%;
	}

	.slick-next {
		right: 8px;
	}

	.slick-prev {
		left: 8px;
	}

	.slick-dots li button:before {
		color: #212121;
	}

	.slick-dots {
		bottom: 8px;
	}

	@media (min-width: 1441px) {
		height: 190px;
	}

	@media (max-width: 767px) {
		height: 200px;
	}
`;

const load = keyframes`
	from{
		left: -150px;
	}

	to{
		left: 100%;
	}
`;

export const LoadingImageContainer = styled.div`
	width: 100%;
	max-width: 250px;
	height: 175px;
	box-sizing: border-box;

	position: relative;

	overflow: hidden;
	border-radius: 16px 16px 0 0;

	&::before {
		content: "";
		display: block;
		position: absolute;
		left: -150px;
		top: 0;
		height: 100%;
		width: 250px;
		background: linear-gradient(
			to right,
			transparent 0%,
			#e8e8e8 50%,
			transparent 100%
		);
		animation: ${load} 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
	}

	@media (min-width: 1441px) {
		max-width: 295px;
		height: 190px;
	}

	@media (max-width: 767px) {
		max-width: 310px;
		height: 200px;
		margin-left: auto;
		margin-right: auto;
	}
`;

export const HouseInformationsAndActionsContainer = styled.div`
	padding: 12px 18px;

	border-bottom: 1px solid #B6B6B6;

	@media(min-width: 1441px){
		padding: 12px 21px;
	}
`;

export const HouseInformationsAndActions = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: center;

	flex-direction: column;

	> span {
		margin-top: 8px;
		min-height: 32px;
		max-height: 48px;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		line-height: 1.35;
		font-size: 11px;
	}

	@media(min-width: 1441px){
		font-size: 13px;
	}
`;

export const HouseTitleAndAction = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
`;

export const TitleContainer = styled.div`
	>h3{
		font-size: 16px;
		color: #6EA5FF;
		font-weight: bold;
	}

	@media(min-width: 1441px){
		>h3{
			font-size: 18px;
		}
	}
`;

export const Actions = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	margin-left: 32px;
	
	>button{
		background: transparent;
		border: 0;
	}

	>img{
		width: 24px;
		height: 24px;
	}

	>a{
		margin-left: 8px;
	}

	@media(min-width: 1441px){
		svg{
			width: 20px;
			height: 20px;
		}
	}
`;

export const HouseAdditionalInfoemationsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	padding: 12px;

	border-bottom: 1px solid #B6B6B6;

	>div{
		display: flex;
		align-items: center;

		>span{
			font-size: 11px;

			margin-left: 4px;
		}

		& + div{
			margin-left: 14px;
		}
	}

	@media(min-width: 1441px){
		padding: 15px 12px;

		>div{
			>svg{
				width: 15px;
				height: 15px;
			}

			>span{
				font-size: 13px;
			}

			& + div{
				margin-left: 22px;
			}
		}
	}
`;

export const HousePrice = styled.div`
	text-align: center;

	padding: 12px 0;

	>b{
		font-size: 12px;
	}

	>h2{
		font-size: 15px;
		color: #DD6435;
		font-weight: bold;

		margin: 6px 0;
	}

	>a{
		text-decoration: none;
		color: #6EA5FF;
		font-weight: 600;
		font-size: 12px;
	}

	@media(min-width: 1441px){
		padding: 15px 0;

		>b{
			font-size: 13px;
		}

		>h2{
			font-size: 17px;

			margin: 4px 0 12px;
		}

		>a{
			font-size: 13px;
		}
	}
`;